import { ConfirmationModal } from 'components/modals/ConfirmationModal';
import { func_validation } from 'functions';
import React, { useState, useEffect, useRef } from 'react';



export function useOnPageExit(props) {
    const {
        isAccountRecordUpdateRequesting: isLoading,
        isAnyInputChanged,
        isAccountRecordUpdatedSuccessfully,
        history,
        isEveryInputValid
    } = props;

    let unblock = useRef();
    const [isPageExitAlertModalVisible, setIsPageExitAlertModalVisible] = useState(false);
    const [redirectPath, setRedirectPath] = useState("");
 
    useEffect(() => {
        if (isAnyInputChanged) {
            unblock.current = history.block(({ pathname }) => {
                setRedirectPath(pathname);
                setIsPageExitAlertModalVisible(true);
    
                return false;
            });
    
            window.onbeforeunload = () => {
                let pathname = history?.location?.pathname;
                setRedirectPath(pathname);
                setIsPageExitAlertModalVisible(true);
        
                return true;
            }
        }
        else {
            if (func_validation.isNotNullUndefined(unblock.current)) 
                unblock.current();
            if (func_validation.isNotNullUndefined(window.onbeforeunload))
                window.onbeforeunload = null;
        }

        return () => {
            if (func_validation.isNotNullUndefined(unblock.current)) 
                unblock.current();
            if (func_validation.isNotNullUndefined(window.onbeforeunload))
                window.onbeforeunload = null;
        }
    }, [isAnyInputChanged]);

    function handleHideFormPage() {
        setIsPageExitAlertModalVisible(true);
        setRedirectPath("");
    }

    function handleSuccessfulSubmission() {
        if (isAccountRecordUpdatedSuccessfully) {
            if (func_validation.isStringTrimNotEmpty(redirectPath)) {
                unblock.current();
                if (func_validation.isNotNullUndefined(window.onbeforeunload))
                    window.onbeforeunload = null;

                history.push(redirectPath);
            }
            else {
                setIsPageExitAlertModalVisible(false);
            }
        }
    }
    useEffect(() => {
        handleSuccessfulSubmission();
    }, [isAccountRecordUpdatedSuccessfully]);

    useEffect(() => {
        if (!isLoading) {
            setIsPageExitAlertModalVisible(false);
        }
    }, [isLoading]);

    let pageExitModal = (
        <ConfirmationModal
            description={"Would you like to save your changes?"}
            cancelButtonText={"No"}
            confirmButtonText={"Yes"}
            isModalVisible={isPageExitAlertModalVisible}
            updateParentState={setIsPageExitAlertModalVisible}
            handleOnConfirm={() => {
                if (func_validation.isFunction(props.handleSubmission))
                    props.handleSubmission();

                if (!isEveryInputValid)
                    setIsPageExitAlertModalVisible(false);
            }}
            handleOnCancel={() => {
                unblock.current();

                if (func_validation.isNotNullUndefined(window.onbeforeunload))
                    window.onbeforeunload = null;

                if (func_validation.isFunction(props.updateParentState_visiblity))
                    props.updateParentState_visiblity(false);

                if (func_validation.isStringTrimNotEmpty(redirectPath)) {
                    history.push(redirectPath);
                }
            }}
            isActionLoading={isLoading}
        />
    );

    return {
        isPageExitAlertModalVisible, handleHideFormPage,
        pageExitModal
    };
}